import type { Cart } from '@/modules/cart/domain/Cart';
import type { CartRepository } from '@/modules/cart/domain/CartRepository';
import type { shippingMethodBodyRequest } from '@/modules/shippingMethod/domain/ShippingMethodRepository';

const updateLineItemQuantity = (
  repository: CartRepository,
  lineItemId: string,
  quantity: number,
  skusHistory: shippingMethodBodyRequest[]
): Promise<Cart> => {
  return repository.updateLineItemQuantity(lineItemId, quantity, skusHistory);
};

export default updateLineItemQuantity;
